import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useEffect, useState } from "react";
import {
    DEFAULT_FIRST_PAGE_NUM,
    DEFAULT_PAGE_SIZE,
} from "@/utils/constants";
import {
    IExternalBillField,
    IExternalBillSearch,
    ITotalVo
} from "./externalBillType"
import { externalBillService } from "./externalBillService"
import useGlobalModel from "@/model/globalModel";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/utils/utils";
import { roleColumnModel } from "@/utils/roleColumn";

export interface IMdBeSearchField {
    code?: string;
    name?: string;
    corporation?: string;
    phone?: string;
    address?: string;
    bank?: string;
    bankAccount?: string;
}

export const useExternalBillModel = createModel(function () {
    const { shopAndOrg, setLoadingInfo, user } = useGlobalModel()
    const { getHideRoleColumns } = roleColumnModel();
    //切换站点清除缓存
    useEffect(() => {
        // setSelectedRowKeys([]);
        reset()
    }, [shopAndOrg.shopCode])
    const initSearchParam: IExternalBillSearch = {};
    const initDataSource: IExternalBillField[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc: ITotalVo = { InTotal: 0, totalNum: 0 }

    //查询条件
    const [searchParam, setSearchParam] = useState<IExternalBillSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IExternalBillField[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IExternalBillField>({});
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //单据汇总
    const [descTotal, setDescTotal] = useState<ITotalVo>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<ITotalVo>(initDesc);
    const [descRows, setDescRows] = useState<IExternalBillField[]>([]);

    //单据汇总
    const [approvalPrintVisible, setApprovalPrintVisible] = useState<any>(false);
    //打印接车单
    const [pickCarPrintVisible, setPickCarPrintVisible] = useState<any>(false);
    //单据汇总
    const [completedPrintVisible, setCompletedPrintVisible] = useState<any>(false);
    const [dispatchVisible, setDispatchVisible] = useState<any>(false);
    //审核弹窗
    const [checkAcceptVisible, setCheckAcceptVisible] = useState<boolean>(false);
    const [completeModalVisible, setCompleteModalVisible] = useState(false);
    const [currentCompleteBillId, setCurrentCompleteBillId] = useState<any>({});
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item, index) => {
            let { inTotal } = item
            newRowsDescTotal.totalNum += +1
            newRowsDescTotal.InTotal += inTotal as number
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IExternalBillField)
    }, [selectedRowKeys])


    const [drawerVisible, setDrawerVisible] = useState(false);

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IMdBeSearchField) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IExternalBillSearch = searchParam) => {
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            orgName: user.orgType == 'out' ? user.orgName : null,
            orgCode: user.orgType == 'out' ? user.orgCode : null,
        }
        let { retData } = await externalBillService.page(searchParams);
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
    }
    const exportExternalBill = async (searchValue: IExternalBillSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            orgName: user.orgType == 'out' ? user.orgName : null,
            orgCode: user.orgType == 'out' ? user.orgCode : null,
        }
        try {
            let result = await externalBillService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    return {
        /***field***/
        searchParam,
        initPgCfg,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        descTotal, setDescTotal,
        selectedRow, setSelectedRow,
        exportExternalBill,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        reset,
        approvalPrintVisible, setApprovalPrintVisible,
        pickCarPrintVisible, setPickCarPrintVisible,
        completedPrintVisible, setCompletedPrintVisible,
        dispatchVisible, setDispatchVisible,
        checkAcceptVisible, setCheckAcceptVisible,
        currentCompleteBillId, setCurrentCompleteBillId,
        completeModalVisible, setCompleteModalVisible
    }
});